export default "__VITE_ASSET__5cfdc05a__"